/* Us vs Them section behavior (loaded deferred by sections/us-vs-them.liquid):
   (i) explanation popups + "Us" column scroll cascade. Idempotent per section
   root via dataset guards, so repeat runs (duplicate tags, editor reloads) are safe. */
(function () {
  function initPopups(root) {
    if (root.dataset.uvtPopupBound === 'true') return;
    root.dataset.uvtPopupBound = 'true';

    function closeAll() {
      var open = root.querySelectorAll('.uvt-popup.is-open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('is-open');
      }
      var btns = root.querySelectorAll('.uvt-info-btn[aria-expanded="true"]');
      for (var j = 0; j < btns.length; j++) {
        btns[j].setAttribute('aria-expanded', 'false');
      }
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('.uvt-info-btn');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var popup = trigger.closest('.uvt-cell').querySelector('.uvt-popup');
        if (!popup) return;
        var willOpen = !popup.classList.contains('is-open');
        closeAll();
        if (willOpen) {
          popup.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (e.target.closest('.uvt-popup-close')) {
        e.preventDefault();
        closeAll();
        return;
      }
      // Clicks inside an open popup should not close it.
      if (e.target.closest('.uvt-popup')) return;
      // Any other click inside the section closes open popups.
      closeAll();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeAll();
    });
  }

  function initCascade(root) {
    if (root.dataset.uvtUsCascade === 'true') return;
    root.dataset.uvtUsCascade = 'true';
    // Respect reduced-motion: leave the Us cells fully visible, no hiding/animation.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Hide the Us cells (via CSS gated on .uvt-anim-ready) so each can float up on scroll.
    root.classList.add('uvt-anim-ready');
    var cells = root.querySelectorAll('.uvt-cell--us:not(.uvt-cell--head)');
    function revealAll() {
      for (var i = 0; i < cells.length; i++) cells[i].classList.add('uvt-in');
    }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    // Each Us cell reveals when IT enters the viewport, so the cascade follows the
    // shopper's scroll instead of firing all at once when the section's top appears.
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('uvt-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 5% 0px' });
    for (var c = 0; c < cells.length; c++) io.observe(cells[c]);
  }

  function initAll(scope) {
    var roots = scope.querySelectorAll('.uvt-section');
    for (var i = 0; i < roots.length; i++) {
      initPopups(roots[i]);
      initCascade(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-bind when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
